import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

export interface DatlazToastData {
  id: string;
  title: string;
  content: string;
  icon?: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  redirectUrl?: string;
  duration?: number;
}

@Component({
  selector: 'app-datlaz-toaster',
  templateUrl: './datlaz-toaster.component.html',
  styleUrls: ['./datlaz-toaster.component.scss']
})
export class DatlazToasterComponent implements OnInit, OnDestroy {
  @Input() toast!: DatlazToastData;
  @Output() close = new EventEmitter<string>();
  @Output() click = new EventEmitter<DatlazToastData>();

  private timeoutId?: number;
  public isVisible = false;

  constructor(private router: Router) {}

  ngOnInit() {
    // Animate in
    setTimeout(() => {
      this.isVisible = true;
    }, 100);

    // Auto close after duration (default 30 seconds)
    const duration = this.toast.duration || 30000;
    this.timeoutId = window.setTimeout(() => {
      this.closeToast();
    }, duration);
  }

  ngOnDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  onToastClick() {
    this.click.emit(this.toast);
    
    // Redirect if URL is provided
    if (this.toast.redirectUrl) {
      this.router.navigate([this.toast.redirectUrl]);
    }
    
    this.closeToast();
  }

  onCloseClick(event: Event) {
    event.stopPropagation();
    this.closeToast();
  }

  private closeToast() {
    this.isVisible = false;
    setTimeout(() => {
      this.close.emit(this.toast.id);
    }, 300); // Wait for animation to complete
  }

  getIconClass(): string {
    if (this.toast.icon) {
      return this.toast.icon;
    }
    
    switch (this.toast.type) {
      case 'success':
        return 'fas fa-check-circle';
      case 'error':
        return 'fas fa-exclamation-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'info':
        return 'fas fa-info-circle';
      default:
        return 'fas fa-bell';
    }
  }

  getTypeClass(): string {
    return this.toast.type || 'info';
  }
}
